var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-progress',{attrs:{"width":160,"text-inside":true,"stroke-width":26,"percentage":_vm.percentage}}),_c('i',{staticClass:"el-icon-loading"}),_c('span',[_vm._v(_vm._s(_vm.perTag))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }